$(function() {
    "use strict";
    $('.cloneable-fieldset').each(function () {
        var $root = $(this);

        var $template = $root.find('.cloneable-fieldset__row_template');
        var $deleteButtons = $root.find('.cloneable-fieldset__delete');
        var $addButton = $root.find('.cloneable-fieldset__add');
        var $emptyContent = $root.find('.cloneable-fieldset__content_empty');
        var $notEmptyContent = $root.find('.cloneable-fieldset__content_not-empty');
        var withEmpty = $emptyContent.length > 0 && $root.data('withEmpty');

        $(document).on('click', $deleteButtons.selector, function(e) {
            e.preventDefault();

            $(this).closest('.cloneable-fieldset__row').remove();

            if (withEmpty && $root.find('.cloneable-fieldset__row').length <= 1) {
                $emptyContent.removeClass('cloneable-fieldset__content_hidden');
                $notEmptyContent.addClass('cloneable-fieldset__content_hidden');
            }
        });

        $addButton.on('click', function() {
            var $newRow = $template.clone(true);
            $newRow.removeClass('cloneable-fieldset__row_template');
            $newRow.addClass('cloneable-fieldset__row_new');
            var count = parseInt($root.find('.cloneable-fieldset__row_new').length);
            $newRow.find('input, select, textarea').each(function() {
                var name = $(this).attr('name');
                if (name && name.match(/form_template/)) {
                    name = name.replace('[form_template]', '[' + count +']');
                    $(this).attr('name', name);
                }
            });

            var $citySelectorFields = $newRow.find('.city-selector_template');
            if ($citySelectorFields.length) {
                $citySelectorFields.each(function() {
                    $(this).removeClass('city-selector_template').addClass('city-selector');
                    $(document).trigger('CitySelector::Init', [$(this)]);
                });
            }

            var $select2Fields = $newRow.find('.select2_template');
            if ($select2Fields.length) {
                $select2Fields.each(function() {
                    $(this).removeClass('select2_template').addClass('select2');
                    $(document).trigger('Select2::Init', [$(this)]);
                });
            }

            $newRow.insertBefore($template);

            if (withEmpty && $root.find('.cloneable-fieldset__row').length > 1) {
                $notEmptyContent.removeClass('cloneable-fieldset__content_hidden');
                $emptyContent.addClass('cloneable-fieldset__content_hidden');
            }
        });
    });
});
